<template>
    <div class="grid">
      <loading
        :active="isLoadingModel"
        :can-cancel="true"
        color="#173EA3"
        :is-full-page="fullPage"
      ></loading>
      <div class="col-12">
        <div class="card">
          <Breadcrumb :home="breadcrumbHome" :model="breadcrumbItems" />
          <Toast />

            <div class="p-fluid formgrid grid" style="margin-top: 2%">

                <div class="field col-12 md:col-2">
                  <span class="p-float-label">
                    <InputText v-model="user_id"> </InputText>
                    <label>Search...</label>                        
                  </span>
                </div>
                
                <div class="field col-12 md:col-2">
                    <span class="p-float-label">
                        <InputText maxlength="10" v-model="mob_no" onkeypress="return event.charCode<=57 && event.charCode>=48"> </InputText>
                        <label>Mobile No</label>
                    </span>
                </div>

                <div class="field col-12 md:col-2">
                  <span class="p-float-label">
                    <Dropdown 
                            id="state" 
                            v-model="user_type_search" 
                            :options="user_type_dropdown" 
                            optionLabel="name" 
                            :optionValue="name"  filter
                            :disabled="hide_dropdown"
                            >
                    </Dropdown>
                    <label for="type">Select Type</label>
                  </span>
                </div>

                <div class="field col-12 md:col-2">
                    <span class="p-float-label">
                      <Calendar
                          v-model="search_date_range"
                          dateFormat="dd-mm-yy"
                          selectionMode="range"
                          :manualInput="false"
                          :numberOfMonths="2"
                          :showTime="false"
                          hourFormat="12"
                              />
                        <label>Date</label>
                    </span>
                </div>

                <div class="field col-12 md:col-2">
                  <span class="p-float-label">
                    <InputText id="email1" type="text" v-model="search_email" />
                    <label for="email1">Email</label>
                  </span>
                </div>
                
                <div class="field col-12 md:col-2" v-if="user_key && (client_group_ids)">                
                    <span class="p-float-label">
                        <MultiSelect
                            style="width: 150px"
                            id="state"
                            filter
                            v-model="client_id_search"
                            :options="client_id_dropdown"
                            optionLabel="name"
                            :optionValue="code"
                        ></MultiSelect>
                        <label>Select Client</label>
                    </span>
                </div>
                <!-- &nbsp;
                <div class="my-2">
                    <span class="p-float-label">
                    <Dropdown 
                    style="width:150px" 
                      id="state" 
                      v-model="user_type_search" 
                      :options="user_type_dropdown" 
                      optionLabel="name" 
                      :optionValue="name"  filter
                      :disabled="hide_dropdown"
                      >
                    </Dropdown>
                    <label for="type">Select Type</label>
                    </span>
                </div> -->
                
                <div class="field col-12 md:col-2">
                    <Button
                      icon="pi pi-search"
                      v-tooltip.bottom="'Search'"
                      @click="search(1)"
                  /> &nbsp;
                  <Button   class="p-button-danger"  icon="pi pi-refresh" @click="reset()" v-tooltip.bottom="'Reset'" />
                </div>
               
           
            <!-- </template>
            <template v-slot:end> -->
              

          </div>
            <!-- </template>
          </Toolbar> -->
          <!-- {{ products }} -->
          <DataTable
            :loading="loading"
            ref="dt"
            :lazy="true"
            :totalRecords="totalRecords"
            :paginator="true"
            :value="products"
            v-model:selection="selectedProducts"
            :dataKey="columns[0]"
            :rows="limit"
            :filters="filters"
            @page="onPage($event)"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25, totalRecords]"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            responsiveLayout="scroll"
            style="font-size: 12px"
            :rowHover="true"
            showGridlines
          >
            <template #empty>
              <b style="text-align: center">No records found.</b>
            </template>
            <template #header>
              <div
                class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
              >
                <h5 class="m-0"><b>Employee Attendance Master</b></h5>
                
                <div>
                  <json-excel :data="product">
                    <Button
                      icon="pi pi-upload"
                      v-tooltip.bottom="'export'"
                    @click="exportCSV"
                    />
                  </json-excel> &nbsp;

                  <!-- <Button
                    icon="pi pi-refresh"
                    @click="search(2)"
                    v-tooltip.bottom="'Refresh'"
                  /> -->
                </div>
              </div>
              <div style="text-align: right; font-weight: bold">
                <span>Total Type:</span>{{ totalRecords }}
              </div>
            </template>
            <Column header="Sr No" style="min-width: 5rem; text-align: left">
              <template #body="{ index }">
                <span v-if="page_no == 1">{{ +index + +1 }}</span>
                <span v-else>{{ +index + 1 + limit * (page_no - 1) }}</span>
              </template>
            </Column>
            <Column header="Type" :field="columns[7]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.user_type }}
              </template>
            </Column>
            <!-- <Column header="Image" :field="columns[9]" style="text-align:center;">
            <template #body="{ data }">
              <img  :src="data.profile_image" 
                    :alt="data.profile_image" 
                    v-if="data.profile_image && data.profile_image!=''" 
                    class="shadow-2"
                    width="30"
                    height="30">
              <img  v-else
                    src="https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o="
                    class="shadow-2"
                    width="50"
            />
            
            </template>
          </Column> -->
            <Column header="Name" :field="columns[2]" style="min-width: 10rem">
              <template #body="{ data }">
                {{ data.first_name }} {{ data.last_name }}
              </template>
            </Column>
            
            <Column
              header="Date"
              :field="columns[8]"
              style="min-width: 5rem"
            >
              <template #body="{ data }">
                {{ data.date }}
              </template>
            </Column>
            <Column
              header="Log-in"
              :field="columns[1]"
              style="min-width: 5rem"
            >
              <template #body="{ data }">
                {{ data.login }}
              </template>
            </Column>
            <Column
              header="Logout"
              :field="columns[9]"
              style="min-width: 5rem"
            >
              <template #body="{ data }">
                {{ data.logout }}
              </template>
            </Column>
            <Column
              header="Total Scans"
              :field="columns[10]"
              style="min-width: 5rem"
            >
              <template #body="{ data }">
                {{ data.totalscans }}
              </template>
            </Column>
            <Column header="Mobile No" :field="columns[5]" style="min-width: 5rem">
              <template #body="{ data }">
                {{ data.mobile_number }}
              </template>
            </Column>
            <Column header="Email" :field="columns[4]" style="min-width: 10rem">
              <template #body="{ data }">
                {{ data.email_id }}
              </template>
            </Column>
          </DataTable>
         

      
        
        </div>
      </div>
    </div>
  </template>
  <script>
  import { FilterMatchMode } from "primevue/api";
  import ProductService from "../service/ProductService";
  import JsonExcel from "vue-json-excel";
  import BreadcrumbService from "../service/BreadcrumbService";
  import apis from "@/apis";
  
  export default {
    data() {
      return {
        client_id_dropdown: [],
        client_id_search:'',
        client_group_ids:'',
        user_key:"",
        user_type_search:'',
        search_date_range:'',
        search_email:'',
        user_type_dropdown: [],
        place_details: "",
        end_place_details: "",
        searchme: "",
        name: "",
        page_no: 1,
        isLoading: false,
        isLoadingModel: false,
        loading: false,
        fullPage: true,
        file_attachment: "",
        icon_dropdown: [],
        user_id: "",
        mob_no:'',
        dropdownItems: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          { name: "Deleted", value: "Deleted" },
        ],
        parent_dropdownItems: [],
        selectstatus: { name: "", value: "" },
        parent_selectstatus: { name: "", value: "" },
        pick_icon: { name: "", value: "" },
        products: null,
        productDialog: false,
        deleteProductDialog: false,
        deleteProductsDialog: false,
        lazyParams: {},
        product: {},
        selectedProducts: null,
        filters: {},
        offset: 1,
        
        limit: 10,
        columns: [],
        
        pageno: 1,
        submitted: false,
        icons: null,
        totalRecords: 0,
        id: "",
        statuses: [
          { label: "INSTOCK", value: "instock" },
          { label: "LOWSTOCK", value: "lowstock" },
          { label: "OUTOFSTOCK", value: "outofstock" },
        ],
        BreadcrumbService: null,
        breadcrumbHome: {},
        breadcrumbItems: [],
      };
    },
    productService: null,
    async created() {
      this.productService = new ProductService();
      this.initFilters();
      this.BreadcrumbService = new BreadcrumbService();
      let Breadcrum_data = this.BreadcrumbService.getBreadcrum(
        "Attendance",
        "/EmployeeAttendanceList"
      );
      this.breadcrumbHome = Breadcrum_data.home;
      this.breadcrumbItems = Breadcrum_data.items;
      this.client_group_ids=localStorage.getItem('client_group_ids');
      this.user_key=localStorage.getItem("user_key");
      this.get_client_list();
      this.get_user_type(localStorage.getItem('client_id'));
    },
    async mounted() {
      this.id = this.$route.params.id;
      this.lazyParams = {
        first: 0,
        rows: this.limit,
        sortField: null,
        sortOrder: null,
        filters: this.filters,
      };
      if (this.totalRecords == 0) {
        await this.get_count();
      }
      await this.get_list();
      //alert(this.id);
    },
    watch: {
      async $route() {
        this.products = [];
        this.columns = [];
        this.totalRecords = 0;
        this.id = this.$route.params.id;
        if (this.id) {
          await this.get_count();
          this.get_list();
        }
      },
    },
    methods: {
        get_client_list()
    {  
      const client_group_ids = localStorage.getItem('client_group_ids') ? JSON.parse(localStorage.getItem('client_group_ids')):[];
      var data = { count: false};
      var promise = apis.getclientist(data);
        promise.then((response) => {
         
          var temp_data = [];

                    for (let x = 0; x < response.data.data.length; x++) {
                        const clientData = response.data.data[x];
                        
                        if (clientData.client_name && (client_group_ids.length === 0 || client_group_ids.includes(clientData._id))) {
                            temp_data.push({ name: clientData.client_name, value: clientData._id });
                        }
                    }

                    this.client_id_dropdown = temp_data;
        });
    },
        get_user_type(client_id) 
    {
       var data = { _id: client_id};
            var promise = apis.user_rolelist(data);
            promise.then((response) => {
            if(response.data.data) 
            {
                    var temp_data = [];
                    for (let x = 0; x < response.data.data.length; x++) {
                        temp_data.push({ name: response.data.data[x].user_role_name, code: response.data.data[x].user_role_name });
                    }
                    this.user_type_dropdown = temp_data;
            }
            });
    },
      dateFormatDMY(inputDate) {
        var postdate = inputDate;
        if (inputDate) {
          inputDate = new Date(inputDate);
          if (inputDate.toString() == "NaN-NaN-NaN") {
            return postdate;
          } else {
            let date = ("0" + inputDate.getDate()).slice(-2);
            // current month
            let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
            // current year
            let year = inputDate.getFullYear();
            if (date.toString() == "aN") {
              return postdate;
            } else {
              return date + "/" + month + "/" + year;
            }
          }
        } else {
          return "";
        }
      },
      reset(){
        this.user_id="";
        this.mob_no="";
        this.client_id_search = "";
        this.search_email ="";
        this.user_type_search = "";
        this.search_date_range ="";
        this.get_list();
        this.get_count();

      },
      async search(count) {
        count == 2 ? (this.user_id = "") : "";
        count == 2 ? (this.mob_no = "") : "";
        count == 2 ? (this.client_id_search = '') : "";
        count == 2 ? (this.search_date_range = "") : "";
        count == 2 ? (this.user_type_search = "") : "";
        count == 2 ? (this.search_email = "") : "";

        await this.get_list();
        await this.get_count();
      },
      async viewProduct(product) {
        // console.log(JSON.stringify(product));
        await localStorage.setItem("saveservicedata", JSON.stringify(product));
        this.$router.push({ name: "serviceProfile" });
      },
      editProduct(product) {
        this.file_attachment = "";
        this.product = { ...product };
        this.productDialog = true;
        this.selectstatus.value = this.product.menu_status;
        this.selectstatus.name = this.product.menu_status;
        this.pick_icon.value = this.product.menu_icon;
        this.pick_icon.name = this.product.menu_icon;
        this.parent_selectstatus = { name: "", value: "" };
        if (this.product.parentmenu.length > 0) {
          this.parent_selectstatus.value = this.product.parentmenu[0]._id;
          this.parent_selectstatus.name =
            this.product.parentmenu[0].parent_menu_name;
        }
      },
      isNumber(evt) {
        const charCode = evt.which ? evt.which : evt.keyCode;
        if (
          charCode > 31 &&
          (charCode < 48 || charCode > 57) &&
          charCode !== 46
        ) {
          evt.preventDefault();
        }
      },
      async onPage(event) {
        this.lazyParams = event;
        this.page_no = event.page + 1;
        this.limit = event.rows;
        if (this.totalRecords > 0) {
          this.get_list();
        }
      },
      get_count: function () {
        
        var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length>0) 
            {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
            }
        var data = {
          count: true,
          user_id: this.user_id,
          mobile_number:this.mob_no,
          email_id:this.search_email,
          user_type:this.user_type_search,
          date_range:this.search_date_range,
          client_id:localStorage.getItem("client_id"),
          client_group_ids:client_group_ids
        };
        this.loading = true;
        var promise = apis.EmployeeAttendanceList(data);
        promise.then((response) => {
          this.loading = false;
          this.totalRecords = response.data.data;
        });
        
      },
      get_list: function () {
       
        var client_group_ids =[];
            if (localStorage.getItem('client_group_ids')) 
            {
                client_group_ids =JSON.parse(localStorage.getItem('client_group_ids'));
            }
            else
            {
                client_group_ids.push(localStorage.getItem('client_id'));
            }
            if (this.client_id_search && this.client_id_search.length>0) 
            {
              client_group_ids = []
              for (let x = 0; x < this.client_id_search.length; x++) {
                client_group_ids.push(this.client_id_search[x].value);
                
              }
             
            }
        var data = {
          limit: this.limit,
          page_no: this.page_no,
          count: false,
          user_id: this.user_id,
          mobile_number:this.mob_no,
          email_id:this.search_email,
          user_type:this.user_type_search,
          date_range:this.search_date_range,
          client_id:localStorage.getItem("client_id"),
          client_group_ids:client_group_ids
        };
        this.loading = true;
        var promise = apis.EmployeeAttendanceList(data, this.id);
        promise.then((response) => {
          this.loading = false;
          console.log(response);
          this.products = response.data.data;
          console.log(this.products[0]);
          if (this.columns.length == 0) {
            if (this.products.length > 0) {
              this.columns = Object.keys(this.products[0]);
            }
          }
        });
        console.log(data);
      },
      formatCurrency(value) {
        if (value)
          return value.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
        return;
      },
      // openNew() {
      //   this.product = {};
      //   this.submitted = false;
      //   this.productDialog = true;
      //   this.selectstatus = { name: "", value: "" };
      //   this.parent_selectstatus = { name: "", value: "" };
      //   this.pick_icon = { name: "", value: "" };
      // },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      confirmDeleteProduct(product) {
        this.product = product;
        this.deleteProductDialog = true;
      },
      deleteProduct() {
        this.products = this.products.filter((val) => val.id !== this.product.id);
        this.deleteProductDialog = false;
        this.product = {};
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Product Deleted",
          life: 3000,
        });
      },
      
      findIndexById(id) {
        let index = -1;
        for (let i = 0; i < this.products.length; i++) {
          if (this.products[i].id === id) {
            index = i;
            break;
          }
        }
        return index;
      },
      createId() {
        let id = "";
        var chars =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 5; i++) {
          id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
      },
      async exportCSV() {
        this.limit = this.totalRecords;
        this.get_list();
        await this.$refs.dt.exportCSV();
      },
      confirmDeleteSelected() {
        this.deleteProductsDialog = true;
      },
      deleteSelectedProducts() {
        this.products = this.products.filter(
          (val) => !this.selectedProducts.includes(val)
        );
        this.deleteProductsDialog = false;
        this.selectedProducts = null;
        this.$toast.add({
          severity: "success",
          summary: "Successful",
          detail: "Products Deleted",
          life: 3000,
        });
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    components: { downloadExcel: JsonExcel },
  };
  </script>
  <style scoped lang="scss">
  @import "../assets/demo/badges.scss";
  @import "../assets/demo/documentation.scss";
  .icons-list {
    i {
      color: var(--text-color-secondary);
    }
  }
  </style>
  